export default __webpack_public_path__ + "static/hw_ultra-c1693092e013c610d7c4cf7ddadb15ce.jpg";